// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"AccesoriosDetalle_spinnerContainer__IvbWJ"};